var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.92,195.68c73.69-19.6,121-127.14,212.53-52.23,79.66,65.19-2.79,148.69-77.84,164.48-65.77,13.84-243.78,14.85-247.46-69.06C67.32,151.3,142.27,206.76,183.92,195.68Z",
    style: {
      fill: "#19A49C",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.92,195.68c73.69-19.6,121-127.14,212.53-52.23,79.66,65.19-2.79,148.69-77.84,164.48-65.77,13.84-243.78,14.85-247.46-69.06C67.32,151.3,142.27,206.76,183.92,195.68Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bus-stop--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.38,
    y: 164.41,
    width: 9.54,
    height: 251.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.38,
    y: 164.41,
    width: 9.54,
    height: 22.84,
    style: {
      fill: "#e0e0e0",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.66,
    y: 78.07,
    width: 80.99,
    height: 102.91,
    rx: 11.11,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.66,
    y: 78.07,
    width: 80.99,
    height: 102.91,
    rx: 11.11,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.85,
    y: 93.19,
    width: 94.59,
    height: 72.68,
    rx: 6.96,
    transform: "translate(301.68 -42.63) rotate(90)",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,132.34h8.14a4.43,4.43,0,0,1,3.12,1,3.26,3.26,0,0,1,1.09,2.5,3.15,3.15,0,0,1-.78,2.14,3.49,3.49,0,0,1-1.51.94,3.94,3.94,0,0,1,2.23,1.25,3.46,3.46,0,0,1,.71,2.23,3.86,3.86,0,0,1-.51,2,3.68,3.68,0,0,1-1.39,1.38,4.64,4.64,0,0,1-1.65.46c-1,.12-1.62.19-1.94.19H151Zm4.39,5.51h1.89a2.16,2.16,0,0,0,1.41-.35,1.25,1.25,0,0,0,.4-1,1.19,1.19,0,0,0-.4-1,2.1,2.1,0,0,0-1.38-.35H155.4Zm0,5.53h2.21a2.49,2.49,0,0,0,1.59-.4,1.37,1.37,0,0,0,.46-1.07,1.21,1.21,0,0,0-.46-1,2.48,2.48,0,0,0-1.6-.38h-2.2Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.93,132.34h4.34v8.37a7.08,7.08,0,0,1-.39,2.36,5.08,5.08,0,0,1-1.22,1.93,4.82,4.82,0,0,1-1.74,1.17,8.87,8.87,0,0,1-3,.47,20.37,20.37,0,0,1-2.24-.14,5.8,5.8,0,0,1-2-.58,4.82,4.82,0,0,1-1.49-1.21,4.47,4.47,0,0,1-.93-1.62,8.33,8.33,0,0,1-.4-2.38v-8.37h4.33v8.57a2.47,2.47,0,0,0,.64,1.8,2.74,2.74,0,0,0,3.53,0,2.44,2.44,0,0,0,.64-1.81Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,141.75l4.13-.26a3.09,3.09,0,0,0,.55,1.53,2.29,2.29,0,0,0,1.92.86,2.13,2.13,0,0,0,1.43-.44,1.26,1.26,0,0,0,0-2,5.56,5.56,0,0,0-2.22-.82,9.46,9.46,0,0,1-4.08-1.7,3.44,3.44,0,0,1-1.23-2.72,3.71,3.71,0,0,1,.63-2.05,4.14,4.14,0,0,1,1.89-1.51,8.77,8.77,0,0,1,3.46-.55,7,7,0,0,1,4.11,1,4.31,4.31,0,0,1,1.68,3.19l-4.09.24a2.16,2.16,0,0,0-.69-1.38,2.19,2.19,0,0,0-1.44-.44,1.69,1.69,0,0,0-1.14.33,1,1,0,0,0-.39.78.79.79,0,0,0,.32.6,3.46,3.46,0,0,0,1.46.52,18.18,18.18,0,0,1,4.08,1.24,4.28,4.28,0,0,1,1.79,1.56,3.91,3.91,0,0,1,.56,2.08,4.46,4.46,0,0,1-.74,2.5,4.73,4.73,0,0,1-2.1,1.73,8.46,8.46,0,0,1-3.38.59q-3.58,0-5-1.38A5.44,5.44,0,0,1,181.39,141.75Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,159.75l4.14-.25a3.09,3.09,0,0,0,.54,1.53,2.31,2.31,0,0,0,1.92.86,2.16,2.16,0,0,0,1.44-.44,1.32,1.32,0,0,0,.5-1,1.29,1.29,0,0,0-.48-1,5.56,5.56,0,0,0-2.23-.82,9.46,9.46,0,0,1-4.07-1.71,3.42,3.42,0,0,1-1.23-2.71,3.69,3.69,0,0,1,.63-2.05,4.14,4.14,0,0,1,1.89-1.51,8.75,8.75,0,0,1,3.46-.56,7.08,7.08,0,0,1,4.11,1,4.34,4.34,0,0,1,1.68,3.19l-4.1.24a2.16,2.16,0,0,0-.68-1.38,2.2,2.2,0,0,0-1.45-.44,1.78,1.78,0,0,0-1.14.32,1,1,0,0,0-.38.79.78.78,0,0,0,.31.6,3.58,3.58,0,0,0,1.46.52,18.48,18.48,0,0,1,4.09,1.24,4.34,4.34,0,0,1,1.79,1.56,4,4,0,0,1,.56,2.08,4.5,4.5,0,0,1-.75,2.5,4.71,4.71,0,0,1-2.09,1.73,8.52,8.52,0,0,1-3.39.59c-2.39,0-4-.46-5-1.38A5.46,5.46,0,0,1,143.78,159.75Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.74,150.34H171v3.48h-4.43v10.59h-4.35V153.82h-4.43Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,157.39A6.66,6.66,0,0,1,179,150.1a7.35,7.35,0,0,1,5.41,1.89,7.1,7.1,0,0,1,1.9,5.28,8.69,8.69,0,0,1-.83,4,5.87,5.87,0,0,1-2.4,2.46,8,8,0,0,1-3.91.88,9.1,9.1,0,0,1-3.94-.76,5.81,5.81,0,0,1-2.52-2.4A7.9,7.9,0,0,1,171.7,157.39Zm4.34,0a4.74,4.74,0,0,0,.79,3.06,3,3,0,0,0,4.33,0,5.19,5.19,0,0,0,.76-3.27,4.31,4.31,0,0,0-.8-2.9,2.73,2.73,0,0,0-2.17-.91,2.63,2.63,0,0,0-2.11.93A4.71,4.71,0,0,0,176,157.4Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.59,150.34h7.22a4.93,4.93,0,0,1,3.54,1.13,4.21,4.21,0,0,1,1.17,3.19,4.32,4.32,0,0,1-1.28,3.33,5.53,5.53,0,0,1-3.91,1.2H193v5.22h-4.36Zm4.36,6H194a2.7,2.7,0,0,0,1.77-.44,1.42,1.42,0,0,0,.5-1.11,1.56,1.56,0,0,0-.44-1.13,2.32,2.32,0,0,0-1.66-.46H193Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.34,95.3H154.5a1.36,1.36,0,0,0-1.31,1L151,103.33a3.61,3.61,0,0,1-2.75,2.47l-1.35.27a1.64,1.64,0,0,0-1.32,1.61v7.06A1.36,1.36,0,0,0,147,116.1h7.44a6.07,6.07,0,0,1,12.14,0h18.22a6.08,6.08,0,0,1,12.15,0h.42a1.36,1.36,0,0,0,1.37-1.36V96.66A1.37,1.37,0,0,0,197.34,95.3Zm-29.18,8.4a1.25,1.25,0,0,1-1.24,1.25h-4.68A1.26,1.26,0,0,1,161,103.7V99a1.25,1.25,0,0,1,1.25-1.24h4.68A1.25,1.25,0,0,1,168.16,99Zm8.76,0a1.25,1.25,0,0,1-1.25,1.25H171a1.25,1.25,0,0,1-1.25-1.25V99A1.25,1.25,0,0,1,171,97.78h4.67A1.25,1.25,0,0,1,176.92,99Zm8.76,0a1.25,1.25,0,0,1-1.25,1.25h-4.67a1.25,1.25,0,0,1-1.25-1.25V99a1.25,1.25,0,0,1,1.25-1.24h4.67A1.25,1.25,0,0,1,185.68,99Zm8.76,0a1.25,1.25,0,0,1-1.25,1.25h-4.68a1.26,1.26,0,0,1-1.25-1.25V99a1.25,1.25,0,0,1,1.25-1.24h4.68A1.25,1.25,0,0,1,194.44,99Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.47,112.41a3.7,3.7,0,1,0,3.71,3.69A3.7,3.7,0,0,0,160.47,112.41Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,112.41a3.7,3.7,0,1,0,3.7,3.69A3.71,3.71,0,0,0,190.85,112.41Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.85,
    y: 93.19,
    width: 94.59,
    height: 72.68,
    rx: 6.96,
    transform: "translate(301.68 -42.63) rotate(90)",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,132.34h8.14a4.43,4.43,0,0,1,3.12,1,3.26,3.26,0,0,1,1.09,2.5,3.15,3.15,0,0,1-.78,2.14,3.49,3.49,0,0,1-1.51.94,3.94,3.94,0,0,1,2.23,1.25,3.46,3.46,0,0,1,.71,2.23,3.86,3.86,0,0,1-.51,2,3.68,3.68,0,0,1-1.39,1.38,4.64,4.64,0,0,1-1.65.46c-1,.12-1.62.19-1.94.19H151Zm4.39,5.51h1.89a2.16,2.16,0,0,0,1.41-.35,1.25,1.25,0,0,0,.4-1,1.19,1.19,0,0,0-.4-1,2.1,2.1,0,0,0-1.38-.35H155.4Zm0,5.53h2.21a2.49,2.49,0,0,0,1.59-.4,1.37,1.37,0,0,0,.46-1.07,1.21,1.21,0,0,0-.46-1,2.48,2.48,0,0,0-1.6-.38h-2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.93,132.34h4.34v8.37a7.08,7.08,0,0,1-.39,2.36,5.08,5.08,0,0,1-1.22,1.93,4.82,4.82,0,0,1-1.74,1.17,8.87,8.87,0,0,1-3,.47,20.37,20.37,0,0,1-2.24-.14,5.8,5.8,0,0,1-2-.58,4.82,4.82,0,0,1-1.49-1.21,4.47,4.47,0,0,1-.93-1.62,8.33,8.33,0,0,1-.4-2.38v-8.37h4.33v8.57a2.47,2.47,0,0,0,.64,1.8,2.74,2.74,0,0,0,3.53,0,2.44,2.44,0,0,0,.64-1.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,141.75l4.13-.26a3.09,3.09,0,0,0,.55,1.53,2.29,2.29,0,0,0,1.92.86,2.13,2.13,0,0,0,1.43-.44,1.26,1.26,0,0,0,0-2,5.56,5.56,0,0,0-2.22-.82,9.46,9.46,0,0,1-4.08-1.7,3.44,3.44,0,0,1-1.23-2.72,3.71,3.71,0,0,1,.63-2.05,4.14,4.14,0,0,1,1.89-1.51,8.77,8.77,0,0,1,3.46-.55,7,7,0,0,1,4.11,1,4.31,4.31,0,0,1,1.68,3.19l-4.09.24a2.16,2.16,0,0,0-.69-1.38,2.19,2.19,0,0,0-1.44-.44,1.69,1.69,0,0,0-1.14.33,1,1,0,0,0-.39.78.79.79,0,0,0,.32.6,3.46,3.46,0,0,0,1.46.52,18.18,18.18,0,0,1,4.08,1.24,4.28,4.28,0,0,1,1.79,1.56,3.91,3.91,0,0,1,.56,2.08,4.46,4.46,0,0,1-.74,2.5,4.73,4.73,0,0,1-2.1,1.73,8.46,8.46,0,0,1-3.38.59q-3.58,0-5-1.38A5.44,5.44,0,0,1,181.39,141.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,159.75l4.14-.25a3.09,3.09,0,0,0,.54,1.53,2.31,2.31,0,0,0,1.92.86,2.16,2.16,0,0,0,1.44-.44,1.32,1.32,0,0,0,.5-1,1.29,1.29,0,0,0-.48-1,5.56,5.56,0,0,0-2.23-.82,9.46,9.46,0,0,1-4.07-1.71,3.42,3.42,0,0,1-1.23-2.71,3.69,3.69,0,0,1,.63-2.05,4.14,4.14,0,0,1,1.89-1.51,8.75,8.75,0,0,1,3.46-.56,7.08,7.08,0,0,1,4.11,1,4.34,4.34,0,0,1,1.68,3.19l-4.1.24a2.16,2.16,0,0,0-.68-1.38,2.2,2.2,0,0,0-1.45-.44,1.78,1.78,0,0,0-1.14.32,1,1,0,0,0-.38.79.78.78,0,0,0,.31.6,3.58,3.58,0,0,0,1.46.52,18.48,18.48,0,0,1,4.09,1.24,4.34,4.34,0,0,1,1.79,1.56,4,4,0,0,1,.56,2.08,4.5,4.5,0,0,1-.75,2.5,4.71,4.71,0,0,1-2.09,1.73,8.52,8.52,0,0,1-3.39.59c-2.39,0-4-.46-5-1.38A5.46,5.46,0,0,1,143.78,159.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.74,150.34H171v3.48h-4.43v10.59h-4.35V153.82h-4.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,157.39A6.66,6.66,0,0,1,179,150.1a7.35,7.35,0,0,1,5.41,1.89,7.1,7.1,0,0,1,1.9,5.28,8.69,8.69,0,0,1-.83,4,5.87,5.87,0,0,1-2.4,2.46,8,8,0,0,1-3.91.88,9.1,9.1,0,0,1-3.94-.76,5.81,5.81,0,0,1-2.52-2.4A7.9,7.9,0,0,1,171.7,157.39Zm4.34,0a4.74,4.74,0,0,0,.79,3.06,3,3,0,0,0,4.33,0,5.19,5.19,0,0,0,.76-3.27,4.31,4.31,0,0,0-.8-2.9,2.73,2.73,0,0,0-2.17-.91,2.63,2.63,0,0,0-2.11.93A4.71,4.71,0,0,0,176,157.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.59,150.34h7.22a4.93,4.93,0,0,1,3.54,1.13,4.21,4.21,0,0,1,1.17,3.19,4.32,4.32,0,0,1-1.28,3.33,5.53,5.53,0,0,1-3.91,1.2H193v5.22h-4.36Zm4.36,6H194a2.7,2.7,0,0,0,1.77-.44,1.42,1.42,0,0,0,.5-1.11,1.56,1.56,0,0,0-.44-1.13,2.32,2.32,0,0,0-1.66-.46H193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.34,95.3H154.5a1.36,1.36,0,0,0-1.31,1L151,103.33a3.61,3.61,0,0,1-2.75,2.47l-1.35.27a1.64,1.64,0,0,0-1.32,1.61v7.06A1.36,1.36,0,0,0,147,116.1h7.44a6.07,6.07,0,0,1,12.14,0h18.22a6.08,6.08,0,0,1,12.15,0h.42a1.36,1.36,0,0,0,1.37-1.36V96.66A1.37,1.37,0,0,0,197.34,95.3Zm-29.18,8.4a1.25,1.25,0,0,1-1.24,1.25h-4.68A1.26,1.26,0,0,1,161,103.7V99a1.25,1.25,0,0,1,1.25-1.24h4.68A1.25,1.25,0,0,1,168.16,99Zm8.76,0a1.25,1.25,0,0,1-1.25,1.25H171a1.25,1.25,0,0,1-1.25-1.25V99A1.25,1.25,0,0,1,171,97.78h4.67A1.25,1.25,0,0,1,176.92,99Zm8.76,0a1.25,1.25,0,0,1-1.25,1.25h-4.67a1.25,1.25,0,0,1-1.25-1.25V99a1.25,1.25,0,0,1,1.25-1.24h4.67A1.25,1.25,0,0,1,185.68,99Zm8.76,0a1.25,1.25,0,0,1-1.25,1.25h-4.68a1.26,1.26,0,0,1-1.25-1.25V99a1.25,1.25,0,0,1,1.25-1.24h4.68A1.25,1.25,0,0,1,194.44,99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.47,112.41a3.7,3.7,0,1,0,3.71,3.69A3.7,3.7,0,0,0,160.47,112.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,112.41a3.7,3.7,0,1,0,3.7,3.69A3.71,3.71,0,0,0,190.85,112.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Seat--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "345.51 353.21 344.69 359.03 340.24 416.24 334.96 416.24 339.4 359.03 340.22 353.21 345.51 353.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.2 353.21 373.02 359.03 377.46 416.24 382.74 416.24 378.3 359.03 377.48 353.21 372.2 353.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.1 353.21 118.27 359.03 113.83 416.24 108.56 416.24 112.99 359.03 113.82 353.21 119.1 353.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.78 353.21 146.6 359.03 151.06 416.24 156.34 416.24 151.9 359.03 151.07 353.21 145.78 353.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.95 295.09 144.71 353.21 143.89 359.03 138.61 359.03 139.43 353.21 147.67 295.09 152.95 295.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.35 295.09 371.11 353.21 370.29 359.03 365.01 359.03 365.83 353.21 374.07 295.09 379.35 295.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.21 343.58 138.23 343.58 142.73 327.4 384.7 327.4 380.21 343.58",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.69 343.58 132.71 343.58 137.2 327.4 379.18 327.4 374.69 343.58",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.21 343.58 138.23 343.58 142.73 327.4 384.7 327.4 380.21 343.58",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.95 303.18 144.97 303.18 149.47 287 391.44 287 386.95 303.18",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.95 303.18 144.97 303.18 149.47 287 391.44 287 386.95 303.18",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.43 303.18 139.45 303.18 143.94 287 385.92 287 381.43 303.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.43 303.18 139.45 303.18 143.94 287 385.92 287 381.43 303.18",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.43 303.18 139.45 303.18 143.94 287 385.92 287 381.43 303.18",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.58 323.37 141.6 323.37 146.1 307.18 388.07 307.18 383.58 323.37",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.06 323.37 136.08 323.37 140.57 307.18 382.55 307.18 378.06 323.37",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.58 323.37 141.6 323.37 146.1 307.18 388.07 307.18 383.58 323.37",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.06 323.37 136.08 323.37 140.57 307.18 382.55 307.18 378.06 323.37",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.06 323.37 136.08 323.37 140.57 307.18 382.55 307.18 378.06 323.37",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.69 343.58 132.71 343.58 137.2 327.4 379.18 327.4 374.69 343.58",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.69 343.58 132.71 343.58 137.2 327.4 379.18 327.4 374.69 343.58",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.7,
    y: 353.21,
    width: 240.91,
    height: 5.82,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.7,
    y: 353.21,
    width: 240.91,
    height: 5.82,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.7,
    y: 353.21,
    width: 240.91,
    height: 5.82,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 353.21,
    width: 33.11,
    height: 5.82,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 353.21,
    width: 33.11,
    height: 5.82,
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.52,415.64a2.13,2.13,0,0,1-1.39-.38,1,1,0,0,1-.31-.92.58.58,0,0,1,.33-.49c.83-.4,3.08,1,3.33,1.19a.19.19,0,0,1,0,.34A8.82,8.82,0,0,1,199.52,415.64Zm-1-1.5a.6.6,0,0,0-.21,0,.24.24,0,0,0-.13.2.66.66,0,0,0,.19.61,3.46,3.46,0,0,0,2.53.13A6.41,6.41,0,0,0,198.52,414.14Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.38,415.38a.15.15,0,0,1-.09,0c-.71-.4-2.07-2-1.91-2.79a.58.58,0,0,1,.57-.48.91.91,0,0,1,.74.23c.81.7.87,2.79.88,2.88a.19.19,0,0,1-.09.16A.16.16,0,0,1,201.38,415.38Zm-1.31-2.93H200c-.23,0-.25.13-.26.18-.09.47.74,1.64,1.44,2.19a4,4,0,0,0-.73-2.23A.55.55,0,0,0,200.07,412.45Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.4 418.64 209.63 418.64 210.54 401.91 203.31 401.91 202.4 418.64",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,414.36h8.12a.6.6,0,0,1,.59.5l1.09,6.42a1.13,1.13,0,0,1-1.12,1.29c-2.84-.05-4.2-.22-7.78-.22-2.19,0-9.45.23-12.48.23s-3.28-3-2-3.27c5.63-1.22,10.53-2.9,12.4-4.5A1.84,1.84,0,0,1,202,414.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,275.6c-2.53,5.37-5.17,10.64-7.91,15.89s-5.56,10.45-8.56,15.62l-1.14,1.94-.29.49-.44.69c-.31.49-.6.82-.91,1.24a30.84,30.84,0,0,1-3.61,3.68,81,81,0,0,1-7.36,5.68,142,142,0,0,1-15.48,9.23l-3-4.55c4.46-3.73,9-7.5,13.25-11.31,2.12-1.9,4.21-3.85,6-5.8a27.84,27.84,0,0,0,2.34-2.83c.11-.2.29-.43.34-.57l.38-.74,1-1.94c5.16-10.4,10.2-21.06,15.48-31.51Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,270.36c2.11,6.47-11.22,25.51-11.22,25.51L249.63,288a93.62,93.62,0,0,1,9.23-16.92C264.37,263.48,272.6,263.27,274.9,270.36Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.45,325.36l-6.73,3.89,4.87,7.16s5.21-2.63,5.76-8Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.43 338.05 217.94 337.5 221.59 336.41 216.72 329.25 212.43 338.05",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.31 401.91 210.54 401.91 210.06 410.54 202.83 410.54 203.31 401.91",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.98 418.64 261.75 418.64 256.47 401.91 263.7 401.91 268.98 418.64",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,414.36h8.12a.59.59,0,0,1,.59.5l1.1,6.42a1.14,1.14,0,0,1-1.13,1.29c-2.83-.05-4.2-.22-7.77-.22-2.2,0-9.45.23-12.49.23s-3.27-3-2-3.27c5.63-1.22,10.53-2.9,12.39-4.5A1.86,1.86,0,0,1,260.4,414.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.7 401.91 256.47 401.91 259.2 410.54 266.43 410.54 263.7 401.91",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,415.64a2.16,2.16,0,0,1-1.4-.38,1,1,0,0,1-.31-.92.59.59,0,0,1,.33-.49c.84-.4,3.09,1,3.34,1.19a.2.2,0,0,1,.08.19.19.19,0,0,1-.14.15A8.72,8.72,0,0,1,258,415.64Zm-1-1.5a.67.67,0,0,0-.22,0,.22.22,0,0,0-.12.2.66.66,0,0,0,.19.61,3.44,3.44,0,0,0,2.52.13A6.38,6.38,0,0,0,257,414.14Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,415.38a.15.15,0,0,1-.09,0c-.71-.4-2.08-2-1.92-2.79a.6.6,0,0,1,.58-.48.93.93,0,0,1,.74.23c.8.7.87,2.79.87,2.88a.19.19,0,0,1-.09.16A.15.15,0,0,1,259.82,415.38Zm-1.31-2.93h-.08c-.22,0-.25.13-.26.18-.09.47.75,1.64,1.44,2.19a3.93,3.93,0,0,0-.72-2.23A.57.57,0,0,0,258.51,412.45Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,267.77c1.35.27,2.49.55,3.7.88s2.37.67,3.55,1q3.52,1.09,7,2.49c2.29.92,4.55,1.95,6.78,3.11,1.12.56,2.22,1.18,3.31,1.81.54.32,1.08.67,1.62,1l.81.51c.05,0,.48.31.76.52a10.68,10.68,0,0,1,.88.78,8.18,8.18,0,0,1,2,3.75,10.12,10.12,0,0,1,.24,3.14,17.86,17.86,0,0,1-1,4.58,39.56,39.56,0,0,1-3.36,7,76.84,76.84,0,0,1-8.64,11.81l-4.44-3.12c2.06-4,4.09-8.24,5.75-12.32a38.12,38.12,0,0,0,1.94-6,8.65,8.65,0,0,0,.25-2.33c0-.26-.09-.41-.1-.34a1.25,1.25,0,0,0,.37.71,1,1,0,0,0,.21.2c0,.05.23.16,0,.05l-.72-.36c-.48-.24-1-.5-1.44-.72-1-.45-2-.92-3-1.34-2-.87-4.07-1.65-6.16-2.39s-4.2-1.42-6.34-2.06c-1.07-.32-2.14-.64-3.21-.93l-3.12-.82Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.56,307.3l-4.38,5.82,9,.62s3-5.87-.17-7.19Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.69 321.27 321.17 321.42 322.21 313.74 313.18 313.12 313.69 321.27",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.92,327.89s-50-1.72-56.68,18.17c-7.33,21.77-5.8,62.11-5.8,62.11H213s4.83-28.79,8.14-43.39c3.44-15.16,52.26-8.27,58.46-13.81,4.95-4.42,7.45-11.9,8.11-23.08Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.92,327.89s-50-1.72-56.68,18.17c-7.33,21.77-5.8,62.11-5.8,62.11H213s4.83-28.79,8.14-43.39c3.44-15.16,52.26-8.27,58.46-13.81,4.95-4.42,7.45-11.9,8.11-23.08Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,327.89S227.56,330.41,231,351.1c3.76,22.66,24.92,57.07,24.92,57.07h12.63s-8.62-33.08-12.61-47.5c-2.75-10,31.33-4.16,37.53-9.7,4.95-4.42,7.45-11.9,8.11-23.08Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,327.89S227.56,330.41,231,351.1c3.76,22.66,24.92,57.07,24.92,57.07h12.63s-8.62-33.08-12.61-47.5c-2.75-10,31.33-4.16,37.53-9.7,4.95-4.42,7.45-11.9,8.11-23.08Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.81 408.47 199.6 408.47 199.21 403.97 214.73 404.37 213.81 408.47",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.3 408.47 255.09 408.47 252.33 403.97 269.21 403.97 269.3 408.47",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,271.18c-2.77-1.34-6-.22-9.47,5.12s-6.5,14.27-6.86,16.82l4.93,2.75S276,278.29,275.08,271.18Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,271.18c-2.77-1.34-6-.22-9.47,5.12s-6.5,14.27-6.86,16.82l4.93,2.75S276,278.29,275.08,271.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.09,265c-.24.93-.47,1.86-.68,2.79,0,0,0,.05,0,.08a168.21,168.21,0,0,0-3.34,20c-2.11,19.32-1.06,35.69-1.47,40H262.92c-6-40.65,3.66-62.47,3.66-62.47s3.23-.88,7.33-1.52c1.24-.2,2.56-.37,3.89-.49a140.62,140.62,0,0,1,16.43,0c1.18.06,2.37.15,3.52.26C302.75,264.16,307.09,265,307.09,265Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.75,263.67l-1.09,1.5c-.21.29-5.23,7.05-15.8,8.95l-.94.17-.87-.41c-3.33-1.57-5.23-3.68-5.64-6.26a6.64,6.64,0,0,1,.5-3.72c1.24-.2,2.56-.37,3.89-.49a140.62,140.62,0,0,1,16.43,0C295.41,263.47,296.6,263.56,297.75,263.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.46,296.66a3.55,3.55,0,0,1-2.55-1.11c-1.43-1.43-2.12-4-1.84-7,.45-4.7,3.14-8.6,6.14-8.87a3.51,3.51,0,0,1,2.86,1.09c1.43,1.44,2.12,4,1.84,7-.45,4.71-3.14,8.61-6.13,8.88Zm2.07-16h-.23c-2.45.22-4.84,3.88-5.23,8-.25,2.6.35,5,1.55,6.18a2.51,2.51,0,0,0,2.07.8c2.44-.22,4.84-3.87,5.23-8,.24-2.6-.35-5-1.56-6.18A2.52,2.52,0,0,0,278.53,280.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.56,244.91c-1.31,5.28-2.84,15,.67,18.5,0,0-4.4,6-13.9,7.76-7.16-3.38-2.53-7.76-2.53-7.76,6-1.41,6-5.78,5.23-9.89Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.27,248.42,283,253.51a16.41,16.41,0,0,1,.36,2.92c2.27-.32,5.49-2.8,5.85-5.16A8,8,0,0,0,289.27,248.42Z",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,228.64c-3.64,1.51-6.09,11.48-1.66,13.77S284.48,225.79,277.6,228.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.6,237c-.81,7.16-.92,11.37-4.73,15.05a9.27,9.27,0,0,1-15.73-4.9c-1.2-6.44.32-17.06,7.48-19.91A9.31,9.31,0,0,1,294.6,237Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,221.28c3.92-2.47,9.91,0,8.7,3.37-1.94,5.45,3.05.22,3,6.67,0,4.21-4.75,14.19-7.75,13.93s-4.15-5.57-2.33-11.47c1.36-4.44-2.39-2.69-7.84-2.15-11.06,1.08-18.67-13.41-5.94-12.63,12.31.75,11-6,11-6s4.43,7.24-2.56,7.27S280.87,226.39,289,221.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.43,244.84a7.29,7.29,0,0,1-4.41,3c-2.36.51-3.28-1.61-2.41-3.74.78-1.92,2.95-4.5,5.22-4.06S298.69,243,297.43,244.84Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.74,226.78a6.22,6.22,0,0,0,4.65-3.2S300.58,229.25,295.74,226.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.64,239c0,.58-.37,1.05-.75,1.05s-.66-.47-.63-1.05.36-1.06.74-1.06S283.67,238.37,283.64,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,239c0,.58-.37,1.05-.75,1.05s-.66-.47-.63-1.05.36-1.06.74-1.06S277.08,238.37,277.05,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.13,239.24a22.32,22.32,0,0,1-3.05,5,3.3,3.3,0,0,0,2.76.52Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.47,246.36a.17.17,0,0,1-.17-.17.16.16,0,0,1,.17-.17,4.92,4.92,0,0,0,3.86-1.81.18.18,0,0,1,.24-.05.17.17,0,0,1,0,.24A5.14,5.14,0,0,1,280.47,246.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75,236.82a.35.35,0,0,1-.28-.14,2.61,2.61,0,0,0-2.12-1.14.32.32,0,0,1-.37-.31.35.35,0,0,1,.32-.37,3.24,3.24,0,0,1,2.73,1.42.35.35,0,0,1-.08.48A.36.36,0,0,1,285.75,236.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.3,236.69a.42.42,0,0,1-.16,0,.35.35,0,0,1-.14-.47,3.56,3.56,0,0,1,2.54-1.91.34.34,0,0,1,.38.29.35.35,0,0,1-.29.39h0a2.86,2.86,0,0,0-2,1.56A.35.35,0,0,1,274.3,236.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.41,267.77v.06s0,.05,0,.08a168.21,168.21,0,0,0-3.34,20c-4.21-5.93-5.45-12.13-4.71-16C299.17,267.63,303.88,267.51,306.41,267.77Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.41,267.77v.06s0,.05,0,.08a168.21,168.21,0,0,0-3.34,20c-4.21-5.93-5.45-12.13-4.71-16C299.17,267.63,303.88,267.51,306.41,267.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,265.67c5.28-4.38,24.53,5.95,24.53,5.95l-11.34,14.21s-2-.45-10-4.05C294.8,278,294.33,270.36,300,265.67Z",
    style: {
      fill: "#19A49C"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusStop);
export default __webpack_public_path__ + "static/media/busStop.6bf665e8a1adba9ffdaf9df9e94f7e92.svg";
export { ForwardRef as ReactComponent };